import { create } from 'zustand';
import { TixOrder, TixSale } from '../types/TixTypes';

interface LoadingState {
	removingSeatsLoading: boolean;
	orderIdsLoading: Record<TixOrder['id'], boolean>;
	saleIdsLoading: Record<TixSale['id'], boolean>;

	setRemovingSeatsLoading: (loading: boolean) => void;

	addSaleIdLoading: (id: string) => void;
	removeSaleIdLoading: (id: string) => void;
	clearSaleIdsLoading: () => void;

	addOrderIdLoading: (id: string) => void;
	removeOrderIdLoading: (id: string) => void;
	clearOrderIdsLoading: () => void;
}

export const useLoadingStore = create<LoadingState>()((set) => ({
	removingSeatsLoading: false,
	orderIdsLoading: {},
	saleIdsLoading: {},
	setRemovingSeatsLoading: (loading: boolean) => set((state) => ({ ...state, removingSeatsLoading: loading })),

	addSaleIdLoading: (id: string) =>
		set((state) => ({ ...state, saleIdsLoading: { ...state.saleIdsLoading, [id]: true } })),
	removeSaleIdLoading: (id: string) =>
		set((state) => ({ ...state, saleIdsLoading: { ...state.saleIdsLoading, [id]: false } })),
	clearSaleIdsLoading: () => set({ saleIdsLoading: {} }),

	addOrderIdLoading: (id: string) =>
		set((state) => ({ ...state, orderIdsLoading: { ...state.orderIdsLoading, [id]: true } })),
	removeOrderIdLoading: (id: string) =>
		set((state) => ({ ...state, orderIdsLoading: { ...state.orderIdsLoading, [id]: false } })),
	clearOrderIdsLoading: () => set({ orderIdsLoading: {} }),
}));
